
<div class="page-boxed">

    <mce-save-cancel [config]="saveCancelConfig()"
                     (action)="onSaveCancelAction($event)">
    </mce-save-cancel>

    <div class="mt-8 flex flex-row gap-4">

        <div class="min-w-0 flex-grow">

            <cable-edit-description [form]="form.description"></cable-edit-description>
            <cable-edit-system-voltage [form]="form.systemVoltage"></cable-edit-system-voltage>
            <cable-edit-earthing [form]="form.earthing" [systemVoltage]="form.systemVoltage"></cable-edit-earthing>
            <cable-edit-load [form]="form.load" [systemVoltage]="form.systemVoltage"></cable-edit-load>

            <cable-edit-protection [form]="form.protection" [systemVoltage]="form.systemVoltage"
                                   [load]="form.load" [settings]="form.settings"></cable-edit-protection>
            <protection-rcd [form]="form.rcd"></protection-rcd>


            <cable-edit-selection [form]="form"></cable-edit-selection>

            <app-earthing-settings [form]="form.earthingSettings" [selectedCable]="form.selectedCable" [systemVoltage]="form.systemVoltage"></app-earthing-settings>
            <app-external-cpc [form]="form.externalCPC" [selectedCable]="form.selectedCable"></app-external-cpc>


            <cable-edit-installation [form]="form"></cable-edit-installation>
            <cable-edit-voltage-drop [form]="form"></cable-edit-voltage-drop>
            <cable-edit-fault-source [form]="form"></cable-edit-fault-source>
            <cable-edit-efl [form]="form"></cable-edit-efl>

            <cable-edit-comments [form]="form.comments"></cable-edit-comments>

        </div>

        @if (showDebugPanel()) { <app-debug-panel [form]="form()" class="hidden md:block"></app-debug-panel> }

    </div>


</div>




